import Vue from 'vue'
import Router from 'vue-router'
// import Service from '@/components/Service'
// import Scene from '@/components/Scene'
const Service = resolve => require(['../components/Service'], resolve)
const Scene = resolve => require(['../components/Scene'], resolve)
const Flow = resolve => require(['../components/Flow'], resolve)
const ApiDoc = resolve => require(['../components/ApiDoc'], resolve)
// const Fast = resolve => require(['../components/DocContent/Fast'], resolve)
// const File = resolve => require(['../components/DocContent/File'], resolve)
// const FileUpdate = resolve => require(['../components/DocContent/FileUpdate'], resolve)

Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Service',
      component: Service
    },
    {
      path: '/Scene',
      name: 'Scene',
      component: Scene
    },
    {
      path: '/Flow/:anchor?',
      name: 'Flow',
      component: Flow
    },
    {
      path: '/ApiDoc',
      redirect: '/ApiDoc/fastIntro',
      name: 'ApiDoc',
      component: ApiDoc,
      children: [
        {
          path: 'fastIntro',
          name: 'fastIntro',
          component: ApiDoc
        },
        {
          path: 'fast',
          name: 'fast',
          component: ApiDoc
        },
        {
          path: 'payFastOrder',
          name: 'payFastOrder',
          component: ApiDoc
        },
        {
          path: 'fastOrderDetail',
          name: 'fastOrderDetail',
          component: ApiDoc
        },
        {
          path: 'cancelFastOrder',
          name: 'cancelFastOrder',
          component: ApiDoc
        },
        {
          path: 'fastModify',
          name: 'fastModify',
          component: ApiDoc
        },
        {
          path: 'fileIntro',
          name: 'fileIntro',
          component: ApiDoc
        },
        {
          path: 'uploadFile',
          name: 'uploadFile',
          component: ApiDoc
        },
        {
          path: 'file',
          name: 'file',
          component: ApiDoc
        },
        {
          path: 'priceNotice',
          name: 'priceNotice',
          component: ApiDoc
        },
        {
          path: 'chargeOrder',
          name: 'chargeOrder',
          component: ApiDoc
        },
        {
          path: 'searchOrder',
          name: 'searchOrder',
          component: ApiDoc
        },
        {
          path: 'cancelOrder',
          name: 'cancelOrder',
          component: ApiDoc
        },
        {
          path: 'searchResult',
          name: 'searchResult',
          component: ApiDoc
        },
        {
          path: 'fileUpdate',
          name: 'fileUpdate',
          component: ApiDoc
        },
        {
          path: 'auth',
          name: 'auth',
          component: ApiDoc
        },
        {
          path: 'accessToken',
          name: 'accessToken',
          component: ApiDoc
        },
        {
          path: 'plugin',
          name: 'plugin',
          component: ApiDoc
        },
        {
          path: 'orderStatus',
          name: 'orderStatus',
          component: ApiDoc
        },
        {
          path: 'interfaceCode',
          name: 'interfaceCode',
          component: ApiDoc
        },
        {
          path: 'notify',
          name: 'notify',
          component: ApiDoc
        }
      ]
    },
    {
      path: '',
      component: Service
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  linkActiveClass: 'nav-router-link-active'
})



// WEBPACK FOOTER //
// ./src/router/index.js